<style scoped lang="scss">

</style>
<template>
  <div class="node-container" style="display: flex;flex-wrap: nowrap;width: 83px;">
    <div :id="id" style="width: 83px;height: 60px;"></div>
  </div>

</template>

<script>
export default {
  name: "web_components_craft_node4",
  inject: ["getGraph", "getNode"],
  data() {
    return {
      option: null,
      chart: null,

      color: '',
      title: '',
      percent: '',
      id: '',


    };
  },
  destroyed(){
  	  this.chart.dispose()
  },
  computed: {},
  mounted() {
    const self = this;
    const node = this.getNode();
    //监听数据改变事件
    node.on("change:data", ({
                              current
                            }) => {
      self.color = current.color;
      self.title = current.title
      self.percent = current.percent
      self.id = current.id
    });

    //初次进入的时候赋值外面传入的数据
    this.color = node.getData().color;
    this.title = node.getData().title;
    this.percent = node.getData().percent;
    this.id = node.getData().id;


    // console.log(node.getData())

    this.$nextTick(() => {
      if (!this.chart) {
        this.initChart()

        this.option.series[0].data = [
          {
            value: this.percent ? (this.percent * 100) : 0.001,
            name: this.title,
            title: {
              offsetCenter: ['0%', '45%'],
              color: '#ffffff'
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '-15%']
            },
            itemStyle: {
              color: this.color,
            }
          }
        ]
        this.chart.setOption(this.option)

      }
    })


  },
  methods: {
    initChart() {

      this.option = {

        series: [
          {
            type: 'gauge',
            startAngle: 200,
            endAngle: -20,
            radius: '120%',
            center: ['50%', '60%'],
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {},

            },
            axisLine: {
              lineStyle: {
                width: 4,
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
            },
            data: [],
            title: {
              fontSize: 14
            },
            detail: {
              width: 10,
              height: 14,
              fontSize: 16,
              color: 'auto',
              formatter: ((value) => {
                return value.toFixed(1) + '%'
              })
            }
          }
        ]
      };


      // this.option = {
      // 	series: [{
      // 		name: 'Pie',
      // 		type: 'pie',
      // 		radius: ['110%', '130%'],
      // 		center:['50%','70%'],
      // 		startAngle: 200,
      // 		avoidLabelOverlap: false,
      // 		itemStyle: {
      // 			borderRadius: 40,
      // 			borderColor: 'transparent',
      // 		},
      // 		label: {
      // 			show: true,
      // 			position: 'center'
      // 		},
      // 		emphasis: {
      // 			label: {
      // 				show: true,
      // 				fontSize: '40',
      // 				fontWeight: 'bold'
      // 			}
      // 		},
      // 		labelLine: {
      // 			show: false
      // 		},
      // 		data: [{
      // 				value: 0,
      // 				name: ''
      // 			},
      // 			{
      // 				value: 2200,
      // 				name: ''
      // 			},
      // 			{
      // 				value: 1400,
      // 				name: '',
      // 				itemStyle: {
      // 					color: 'transparent',
      // 				}
      // 			},

      // 		]
      // 	}]
      // };
      var chartDom = document.getElementById(this.id);
      this.chart = this.echarts.init(chartDom);
      this.chart.setOption(this.option);
    },
    add() {
      this.utils.event_hub.$emit('node4Tap', {
        item: this.item
      });
      // const node = this.getNode();
      // const { num } = node.getData();
      // node.setData({
      //   num: num + 1,
      // });
    },
  },
};
</script>
